import type { DSLContext } from '@commenda/types/src/commenda-os-dsl';

const ALLOWED_CONTEXT_KEYS = new Set([
  'companyId',
  'corporationId',
  'directorId',
  'serviceRequestId',
  'transferPricingPolicyId',
  'transferPricingBenchmarkId',
]);

/**
 * Strip context keys the backend DTO doesn't accept (e.g. `serviceRequestId`
 * leaked from workflow runtime context).
 */
export function sanitizeDSLContext(context: DSLContext): DSLContext {
  const clean: Record<string, unknown> = {};
  Object.keys(context).forEach((key) => {
    if (ALLOWED_CONTEXT_KEYS.has(key) && context[key] != null) {
      clean[key] = context[key];
    }
  });
  return clean as DSLContext;
}
